
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

const TIMEOUT = 100;

@Component
export default class AnswerBlockInput extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: 0 }) readonly loopIndex: number | undefined;
  @Prop({ type: Boolean, default: true }) readonly fit!: boolean;

  filled = true;

  completeMask(payload: boolean) {
    if (!this.answerBlockData.mask) return;

    this.filled = payload;
  }

  @Watch("input")
  updateAnswer(value: string) {
    const { index, answerBlockData, loopIndex } = this;

    if (this.index == null) return;

    const timeout = this.answerBlockData.mask ? TIMEOUT : 0;

    setTimeout(() => {
      SMQuestionnaire.updateAnswer({
        index,
        value: value.trim(),
        required: answerBlockData.is_required,
        answer_block_id: answerBlockData.ID,
        answer_block_alias: this.answerBlockData.answer_block_alias,
        loop_index: loopIndex,
        condition: this.answerBlockData.condition,
        filled: !!this.filled,
      });
    }, timeout);
  }

  input = "";

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index == null || !answer) return;

    this.input = answer.value;

    this.filled = !this.answerBlockData.mask;
  }

  get errors() {
    return SMQuestionnaire.errors;
  }

  rules = [
    () => {
      const error = this.errors.find(
        (error) =>
          error.loop_index === this.loopIndex && error.answer_block_id === this.answerBlockData.ID
      );

      if (error) return error.error_message;

      return true;
    },
  ];
}
